import React from "react";
import { Link } from "react-router";
import styles from "./ImLanding.module.css";

const ImLanding = () => {
    return (
        <div className={styles.landing}>
            {/* Headline */}
            <section className={styles.headline}>
                <h1>Effortless Stock Management at Your Fingertips</h1>
                <p>
                    Update, track, and control your inventory in real-time with simple
                    bulk uploads and smart versioning.
                </p>
            </section>

            {/* Hero Section */}
            <section className={styles.hero}>
                <div className={styles.heroContent}>
                    <h2>Manage All Your Products in One Place</h2>
                    <p>
                        Whether you’re updating a single item or uploading thousands at
                        once, our system ensures smooth, accurate, and reliable stock
                        management.
                    </p>
                    <div className={styles.buttons}>
                        <Link to={`/manage/inventory/add-products`} className={styles.primaryBtn}>Upload Products Now</Link>
                        <Link to={`/manage/inventory/add-stock`} className={styles.secondaryBtn}>Manage Stock Items</Link>
                    </div>
                </div>
            </section>

            {/* Key Features */}
            <section className={styles.features}>
                <h2>Key Features</h2>
                <div className={styles.featureList}>
                    <div className={styles.feature}>
                        <h3>1. Bulk Uploads Made Simple</h3>
                        <p>
                            Upload your stock details directly through Excel or CSV files. No
                            manual data entry, no hassle.
                        </p>
                    </div>
                    <div className={styles.feature}>
                        <h3>2. Instant Update Summary</h3>
                        <p>
                            Get a detailed report after every upload—highlighting successful
                            updates, errors, and skipped entries.
                        </p>
                    </div>
                    <div className={styles.feature}>
                        <h3>3. Rollback & Version Control</h3>
                        <p>
                            Made a mistake? No worries. Roll back to a previous version of your
                            stock update anytime.
                        </p>
                    </div>
                    <div className={styles.feature}>
                        <h3>4. Real-Time Tracking</h3>
                        <p>
                            Always stay in control with instant sync and up-to-date stock
                            information across all your products.
                        </p>
                    </div>
                    <div className={styles.feature}>
                        <h3>5. Smart Error Handling</h3>
                        <p>
                            Our system automatically flags mismatched or duplicate entries and
                            provides clear fixes.
                        </p>
                    </div>
                </div>
            </section>

            {/* Why Choose Us */}
            <section className={styles.whyUs}>
                <h2>Why Choose Us</h2>
                <ul>
                    <li>Save hours of manual work with bulk uploads.</li>
                    <li>Reduce errors with smart validations.</li>
                    <li>Maintain complete stock history for accountability.</li>
                    <li>Scale seamlessly as your product catalog grows.</li>
                </ul>
            </section>

            {/* How It Works */}
            <section className={styles.howItWorks}>
                <h2>How It Works</h2>
                <ol>
                    <li><strong>Download Template</strong> → Get the formatted Excel/CSV sheet.</li>
                    <li><strong>Fill In Your Products</strong> → Add or update stock details.</li>
                    <li><strong>Upload in One Click</strong> → Instantly update your entire inventory.</li>
                    <li><strong>Review & Rollback</strong> → Check the update summary and revert if needed.</li>
                </ol>
            </section>

            {/* Testimonials (optional) */}
            <section className={styles.testimonials}>
                <blockquote>
                    “Bulk uploads save us hours every week, and rollback gives peace of
                    mind. Game changer!”
                </blockquote>
                <cite>– Our Partners</cite>
            </section>

            {/* Final CTA */}
            {/* <section className={styles.finalCTA}>
                <h2>Take full control of your stock today.</h2>
                <div className={styles.buttons}>
                    <button className={styles.primaryBtn}>Start Uploading Now</button>
                    <button className={styles.secondaryBtn}>Talk to Support</button>
                </div>
            </section> */}
        </div>
    );
};

export default ImLanding;
